import fs.IDirectory

class PackManager(val root: IDirectory<*, *, *>) {
}
